import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { catchError, firstValueFrom, map, Observable, of, switchMap } from 'rxjs';

export interface HPSTokenResponse {
  "object": "token",
  "token_value": string;
  "token_type": "supt",
  "token_expire": string;
  "card": {
    "number": string;
  }
  global_config_version: string;
}

export interface MeterFeederConfig {
  global_config_version: string;
  hps: {
      publicApiKey: string;
      url: string;
  };
}
export interface CardConnectRequest {
  account: string;
  devicedata?: string;
  cvv?: string;
  expiry?: string;
  signature?: string;
  encryptionhandler?: 'RSA' | 'EC_APPLE_PAY' | 'EC_GOOGLE_PAY';
  source?: string;
  unique?: true;
}

export interface CardConnectTokenResponse {
  message: string;
  errorcode: number;
  token: string;
}

export interface HPSErrorResponse {
    message: string;
    param: string;
}

@Injectable({
  providedIn: 'root'
})
export class NgMultiGatewayPaymentsService {

  constructor(private http: HttpClient) { }

  hpsTokenize(
    environment: {API_URL: string; hpsV1: {publicKey: string; url: string;}; global_config_version: string}, // Assuming environment is passed in for API URL and keys
    ccnum: string, month: string, year: string, cvc: string
  ): Observable<HPSTokenResponse> {
    return this.http.get<MeterFeederConfig>(environment.API_URL + '/status/config', { responseType: 'json' })
      .pipe(
        catchError((error) => {
          // eslint-disable-next-line no-console
          console.error('Error fetching MeterFeeder configuration:', error);
          // Fallback to default HPS configuration wrapped in an observable
          const config: MeterFeederConfig = {
            global_config_version: 'v1',
            hps: {
              publicApiKey: environment.hpsV1.publicKey,
              url: environment.hpsV1.url
            }
          };
          return of(config);
        }),
        switchMap((config: MeterFeederConfig) => {
          if (!config.hps || !config.hps.publicApiKey || !config.hps.publicApiKey) {
              throw new Error('HPS configuration is not set');
          }
          const url = `${config.hps.url}?token_type=supt&object=token&_method=post&` +
            `api_key=${config.hps.publicApiKey}&card%5Bnumber%5D=${ccnum}&card%5Bexp_month%5D=${month}&` +
            `card%5Bexp_year%5D=${year}&card%5Bcvc%5D=${cvc}`;
      
          return this.http.get<HPSTokenResponse>(url)
            // nested pipe to access config.
            .pipe(
              map((response: HPSTokenResponse) => {
                if (response.object === 'token') {
                  response.global_config_version = config.global_config_version;
                }
                return response as HPSTokenResponse;
              })
            );
        })
      );
  }

  cardConnectTokenize(
    uri: string,
    data: CardConnectRequest
  ): Promise<CardConnectTokenResponse> {
    const url = `${uri}/cardsecure/api/v1/ccn/tokenize`;

    return firstValueFrom(
      this.http.post<CardConnectTokenResponse>(url, data, {
        headers: {
          'content-type': 'application/json'
        }
      })
    )
  }
}
